export function normalizePhoneBr(
  raw: string | null | undefined,
): string | null {
  if (!raw) return null;

  const digits = raw.replace(/\D/g, '');

  if (digits.length === 10 || digits.length === 11) {
    return `55${digits}`;
  }

  if (digits.length === 12 || digits.length === 13) {
    return digits.startsWith('55') ? digits : null;
  }

  return null;
}

export function buildWhatsAppUrl(
  phone: string | null | undefined,
  text?: string,
): string | null {
  const normalized = normalizePhoneBr(phone);
  if (!normalized) return null;

  const base = `https://wa.me/${normalized}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

export function buildTelUrl(phone: string | null | undefined): string | null {
  const normalized = normalizePhoneBr(phone);
  if (!normalized) return null;

  return `tel:+${normalized}`;
}

export function buildMailtoUrl(
  email: string | null | undefined,
): string | null {
  if (!email) return null;
  const trimmed = email.trim();
  if (!trimmed) return null;

  return `mailto:${trimmed}`;
}

export function buildInstagramUrl(
  handle: string | null | undefined,
): string | null {
  if (!handle) return null;

  const clean = handle.trim().replace(/^@+/, '');
  if (!clean) return null;

  return `https://instagram.com/${clean}`;
}
